'use client'

import { createHashRouter } from 'react-router-dom'

let router

const AppRouter = (routes) => {
  if (!router && routes) {
    router = createHashRouter(routes)
  }

  return router
}

export default AppRouter
